/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import {
    EventModelFromJSON,
    EventModelFromJSONTyped,
    EventModelToJSON,
} from './EventModel';
import type { FormFieldCheckboxModel } from './FormFieldCheckboxModel';
import {
    FormFieldCheckboxModelFromJSON,
    FormFieldCheckboxModelFromJSONTyped,
    FormFieldCheckboxModelToJSON,
} from './FormFieldCheckboxModel';
import type { FormFieldCollapsibleModel } from './FormFieldCollapsibleModel';
import {
    FormFieldCollapsibleModelFromJSON,
    FormFieldCollapsibleModelFromJSONTyped,
    FormFieldCollapsibleModelToJSON,
} from './FormFieldCollapsibleModel';
import type { FormFieldConfigModel } from './FormFieldConfigModel';
import {
    FormFieldConfigModelFromJSON,
    FormFieldConfigModelFromJSONTyped,
    FormFieldConfigModelToJSON,
} from './FormFieldConfigModel';
import type { FormFieldSelectValueModel } from './FormFieldSelectValueModel';
import {
    FormFieldSelectValueModelFromJSON,
    FormFieldSelectValueModelFromJSONTyped,
    FormFieldSelectValueModelToJSON,
} from './FormFieldSelectValueModel';

/**
 * 
 * @export
 * @interface PetV2FormFieldModel
 */
export interface PetV2FormFieldModel {
    /**
     * This is the name of the pet attribute, which matches the PetProfile attribute names defined in the API spec for pet-profile-a/b.
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    name: PetV2FormFieldModelNameEnum;
    /**
     * The order the FormField should display on the form. Ordering starts from 1 as the highest order.
     * @type {number}
     * @memberof PetV2FormFieldModel
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    type: PetV2FormFieldModelTypeEnum;
    /**
     * The label that is displayed to the customer to let them know what the field represents
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    label: string;
    /**
     * The placeholder text that is displayed when a value is not set.
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    placeholder: string;
    /**
     * The placeholder text that is displayed to the customer to further describe what they should enter in the field.
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PetV2FormFieldModel
     */
    isDerived: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetV2FormFieldModel
     */
    value?: string;
    /**
     * 
     * @type {Array<FormFieldSelectValueModel>}
     * @memberof PetV2FormFieldModel
     */
    values?: Array<FormFieldSelectValueModel>;
    /**
     * 
     * @type {FormFieldCheckboxModel}
     * @memberof PetV2FormFieldModel
     */
    checkbox?: FormFieldCheckboxModel;
    /**
     * 
     * @type {FormFieldCollapsibleModel}
     * @memberof PetV2FormFieldModel
     */
    collapsible?: FormFieldCollapsibleModel;
    /**
     * 
     * @type {FormFieldConfigModel}
     * @memberof PetV2FormFieldModel
     */
    config: FormFieldConfigModel;
    /**
     * 
     * @type {EventModel}
     * @memberof PetV2FormFieldModel
     */
    event: EventModel;
}


/**
 * @export
 */
export const PetV2FormFieldModelNameEnum = {
    Name: 'name',
    Breeds: 'breeds',
    Birthday: 'birthday',
    AdoptionDate: 'adoptionDate',
    Weight: 'weight',
    GenderAndSterilization: 'genderAndSterilization',
    Medications: 'medications',
    MedicationAllergies: 'medicationAllergies',
    MedicalConditions: 'medicalConditions',
    RidingStyles: 'ridingStyles',
    PrimaryDisciplines: 'primaryDisciplines',
    Type: 'type'
} as const;
export type PetV2FormFieldModelNameEnum = typeof PetV2FormFieldModelNameEnum[keyof typeof PetV2FormFieldModelNameEnum];

/**
 * @export
 */
export const PetV2FormFieldModelTypeEnum = {
    Text: 'text',
    Number: 'number',
    Date: 'date',
    Select: 'select'
} as const;
export type PetV2FormFieldModelTypeEnum = typeof PetV2FormFieldModelTypeEnum[keyof typeof PetV2FormFieldModelTypeEnum];


/**
 * Check if a given object implements the PetV2FormFieldModel interface.
 */
export function instanceOfPetV2FormFieldModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "placeholder" in value;
    isInstance = isInstance && "isDerived" in value;
    isInstance = isInstance && "config" in value;
    isInstance = isInstance && "event" in value;

    return isInstance;
}

export function PetV2FormFieldModelFromJSON(json: any): PetV2FormFieldModel {
    return PetV2FormFieldModelFromJSONTyped(json, false);
}

export function PetV2FormFieldModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2FormFieldModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'order': json['order'],
        'type': json['type'],
        'label': json['label'],
        'placeholder': json['placeholder'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'isDerived': json['isDerived'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(FormFieldSelectValueModelFromJSON)),
        'checkbox': !exists(json, 'checkbox') ? undefined : FormFieldCheckboxModelFromJSON(json['checkbox']),
        'collapsible': !exists(json, 'collapsible') ? undefined : FormFieldCollapsibleModelFromJSON(json['collapsible']),
        'config': FormFieldConfigModelFromJSON(json['config']),
        'event': EventModelFromJSON(json['event']),
    };
}

export function PetV2FormFieldModelToJSON(value?: PetV2FormFieldModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'order': value.order,
        'type': value.type,
        'label': value.label,
        'placeholder': value.placeholder,
        'note': value.note,
        'isDerived': value.isDerived,
        'value': value.value,
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(FormFieldSelectValueModelToJSON)),
        'checkbox': FormFieldCheckboxModelToJSON(value.checkbox),
        'collapsible': FormFieldCollapsibleModelToJSON(value.collapsible),
        'config': FormFieldConfigModelToJSON(value.config),
        'event': EventModelToJSON(value.event),
    };
}

